// @ts-check
import React, { useState } from 'react';

import IconButton from '@liquidweb-dev/undercurrent/IconButton';
import InputAdornment from '@liquidweb-dev/undercurrent/InputAdornment';
import AnimatedEyeIcon from '@liquidweb-dev/undercurrent/icons/animated/Eye';
import HookedTextField from '../HookedTextField';

/** @type {typeof HookedTextField} */
const HookedTextFieldPassword = (props) => {
	const { slotProps, ...rest } = props;
	const { input: inputSlotProps, ...restSlotProps } = slotProps || {};
	const [showPassword, setShowPassword] = useState(false);

	return (
		<HookedTextField
			{...rest}
			type={showPassword ? 'text' : 'password'}
			slotProps={{
				...restSlotProps,
				input: {
					...inputSlotProps,
					endAdornment: (
						<>
							<InputAdornment position="end">
								<IconButton
									variant="barebones"
									onClick={() => setShowPassword((prev) => !prev)}
								>
									<AnimatedEyeIcon
										show={showPassword}
										sx={{
											height: (theme) => theme.size.xS,
											width: (theme) => theme.size.xS,
										}}
									/>
								</IconButton>
							</InputAdornment>
							{inputSlotProps?.endAdornment}
						</>
					),
				},
			}}
		/>
	);
};

export default HookedTextFieldPassword;
